<template>
  <div>
    <div class="vx-row mb-6" style="width: 50%">
      <div class="vx-col sm:w-1/3 w-full flex items-center">
        <span>Territory</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <multiselect
          class="selectExample"
          v-model="selectedTerritory"
          :options="optionTerritory"
          :multiple="false"
          track-by="id"
          :allow-empty="false"
          :group-select="false"
          :max-height="100"
          :limit="3"
          placeholder="Type to search"
          :custom-label="customLableTerritory"
        />
      </div>
    </div>
    <div class="vx-row mb-6" style="width: 50%">
      <div class="vx-col sm:w-1/3 w-full flex items-center">
        <span>Sales Supervisor</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <multiselect
          class="selectExample"
          v-model="selectedSalesSupervisor"
          :options="optionSalesSupervisor"
          :multiple="true"
          track-by="personal_id"
          :allow-empty="false"
          :group-select="false"
          :max-height="100"
          :limit="3"
          placeholder="Type to search"
          :searchable="true"
          :custom-label="customLableSalesSupervisor"
          @search-change="handleSearchSupervisor"
        />
      </div>
    </div>
    <div class="vx-row mb-6" style="width: 50%">
      <div class="vx-col sm:w-1/3 w-full flex items-center">
        <span>Sales ID/Name</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <multiselect
          class="selectExample"
          v-model="selectedSales"
          :options="optionSales"
          :multiple="true"
          track-by="personal_id"
          :allow-empty="false"
          :group-select="false"
          :max-height="100"
          :limit="3"
          placeholder="Type to search"
          :searchable="true"
          :custom-label="customLableSales"
          @search-change="handleSearchSales"
        />
      </div>
    </div>
    <div class="vx-row mb-6" style="width: 50%">
      <div class="vx-col sm:w-1/3 w-full flex items-center">
        <span>Daily Closing Status</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <multiselect
          v-model="selectedDailyClosingStatus"
          :options="optionDailyClosingStatus"
          :multiple="true"
          :allow-empty="false"
          :group-select="false"
          :max-height="100"
          :limit="3"
          placeholder="Type to search"
          label="label"
          track-by="value"
        />
      </div>
    </div>
    <div class="vx-row mb-6" style="width: 50%">
      <div class="vx-col sm:w-1/3 w-full flex items-center">
        <span>Only Daily Closing Exception</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <vs-switch v-model="onlyException">
          <span slot="on">Yes</span>
          <span slot="off">No</span>
        </vs-switch>
      </div>
    </div>
    <div class="vx-row mb-6" style="width: 50%">
      <div class="vx-col sm:w-1/3 w-full flex items-center">
        <span>Daily Closing Date</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full flex">
        <date-range-picker
        style="min-height: 40px"
        class="w-full"
        ref="picker"
        opens="center"
        :locale-data="{ firstDay: 1, format: 'dd Mon yyyy' }"
        :singleDatePicker="false"
        :timePicker="false"
        :timePicker24Hour="false"
        :showWeekNumbers="false"
        :showDropdowns="false"
        :autoApply="true"
        :clear="true"
        v-model="validity"
        :linkedCalendars="true"
      >
        <template v-slot:input="picker">
          {{ dateFormat(picker.startDate) }} -
          {{ dateFormat(picker.endDate) }}
        </template>
      </date-range-picker>
      </div>
    </div>

    <div class="vx-row mt-2 ml-2">
      <vs-button
        class="ml-2"
        color="primary"
        type="border"
        icon-pack="feather"
        icon="icon-plus"
        @click="handleFilter()"
        >Filter</vs-button
      >

      <!-- export -->
      <vs-button
        class="ml-2"
        color="primary"
        type="border"
        icon-pack="feather"
        icon="icon-download"
        @click="handleExport('excel')"
        >Export</vs-button
      >

      <!-- reset -->
      <vs-button
        class="ml-2"
        color="danger"
        type="filled"
        icon-pack="feather"
        icon="icon-refresh-cw"
        @click="handleReset()"
        >Reset</vs-button
      >
    </div>

    <div class="">
      <vs-table
        search
        stripe
        border
        description
        :sst="false"
        :data="table.data"
        :max-items="table.length"
        :total="table.length"
        @change-page="handleChangePage"
      >
        <template slot="thead">
          <vs-th>No</vs-th>
          <vs-th>Daily Closing Date</vs-th>
          <vs-th>Territory Code</vs-th>
          <vs-th>Territory Name</vs-th>
          <vs-th>Supervisor Code</vs-th>
          <vs-th>Supervisor Name</vs-th>
          <vs-th>Sales Code</vs-th>
          <vs-th>Sales Code Desc.</vs-th>
          <vs-th>Start Session</vs-th>
          <vs-th>End Session</vs-th>
          <vs-th>Call Plan</vs-th>
          <vs-th>Visited (In Route)</vs-th>
          <vs-th>Visited (%)</vs-th>
          <vs-th>Visited (Out Of Route)</vs-th>
          <vs-th>Effective Call (In Route)</vs-th>
          <vs-th>Effective Call (Out Of Route)</vs-th>
          <vs-th>Count of SO</vs-th>
          <vs-th>SO Gross Value</vs-th>
          <vs-th>SO Net Value</vs-th>
          <vs-th>Count Of AR Collection</vs-th>
          <vs-th>AR Outstanding Value</vs-th>
          <vs-th>Count Of AR Collected</vs-th>
          <vs-th>AR Collected Value</vs-th>
          <vs-th>CIT Complete</vs-th>
          <vs-th>Handover Complete</vs-th>
          <vs-th>Daily Closing</vs-th>
          <vs-th>Daily Closing Status</vs-th>
          <vs-th>Daily Closing With Exception Status</vs-th>
          <vs-th>Daily Closing With Exception Note</vs-th>
        </template>
        <template slot="header">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2"
                >{{ this.table.start }} - {{ this.table.end }} of
                {{ this.table.total }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item
                v-for="item in table.limits"
                :key="item"
                @click="handleChangelength(item)"
              >
                <span>{{ item }}</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{ table.row_number_start + indextr }}</vs-td>
            <vs-td>{{ formatDate(tr.daily_closing_date) }}</vs-td>
            <vs-td>{{ tr.territory_code }}</vs-td>
            <vs-td>{{ tr.territory_name }}</vs-td>
            <vs-td>{{ tr.supervisor_code }}</vs-td>
            <vs-td>{{ tr.supervisor_name }}</vs-td>
            <vs-td>{{ tr.sales_code }}</vs-td>
            <vs-td>{{ tr.sales_code_desc }}</vs-td>
            <vs-td>{{ formatDateTime(tr.start_session) }}</vs-td>
            <vs-td>{{ formatDateTime(tr.end_session) }}</vs-td>
            <vs-td>{{ tr.call_plan }}</vs-td>
            <vs-td>{{ tr.visited_in_route }}</vs-td>
            <vs-td>{{ tr.visited_percentage }}</vs-td>
            <vs-td>{{ tr.visited_out_off_route }}</vs-td>
            <vs-td>{{ tr.effective_call_in_route }}</vs-td>
            <vs-td>{{ tr.effective_call_out_off_route }}</vs-td>
            <vs-td>{{ tr.count_so }}</vs-td>
            <vs-td>{{ formatNumber(tr.so_gross_value) }}</vs-td>
            <vs-td>{{ formatNumber(tr.so_net_value) }}</vs-td>
            <vs-td>{{ tr.count_ar_collection }}</vs-td>
            <vs-td>{{ formatNumber(tr.ar_outstanding_value) }}</vs-td>
            <vs-td>{{ tr.count_ar_collected }}</vs-td>
            <vs-td>{{ formatNumber(tr.ar_collected_value) }}</vs-td>
            <vs-td>{{ formatDateCIT(tr.cit_complete) }}</vs-td>
            <vs-td>{{ formatDateCIT(tr.handover_complete) }}</vs-td>
            <vs-td>{{ formatDateCIT(tr.daily_closing_end) }}</vs-td>
            <vs-td>{{ tr.daily_closing_status }}</vs-td>
            <vs-td>{{ tr.exception_status }}</vs-td>
            <vs-td>{{ tr.exception_notes }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination
        style="padding-top: 5px"
        :total="table.totalPage"
        v-model="setPage"
      />
    </div>
  </div>
</template>

<script>
import { currencyFormat, formatNumber } from "@/utils/common";
import moment from "moment";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

export default {
  components: {
    DateRangePicker,
  },
  data() {
    const today = moment();

    return {
      table: this.tableDefaultState(),
      optionTerritory: [],
      selectedTerritory: [],
      territoryID: 0,
      territoryIDs: "0",
      ALL_TERRITORY: {
        id: 0,
        code: "ALL",
        name: "",
      },

      optionSalesSupervisor: [],
      selectedSalesSupervisor: [],
      spvIDs: "0",
      ALL_OPTION: {
        personal_id: 0,
        personal_name: "All",
        persona_work_id_number: "All"
      },

      optionSales: [],
      selectedSales: [],
      salesIDs: "0",
      ALL_OPTION_SALES: {
        personal_id: 0,
        personal: {
          code_external: "ALL",
          name: "All"
        }
      },

      selectedDailyClosingStatus: [],
      optionDailyClosingStatus: [
        { id:0, label: "ALL", value: "ALL" },
        { id:1, label: "No Activity", value: "no_activity" },
        { id:2, label: "Not Yet Daily Closing", value: "not_yet" },
        { id:3, label: "Daily Closing Done", value: "done" },
      ],
      dailyClosingStatusIDs: "0",

      onlyException: false,
      validity: {
        startDate: today,
        endDate: today,
      },
    };
  },
  methods: {
    formatNumber,
    currencyFormat,
    handleReset() {
      // reload
      this.$router.go(0);
    },
    handleExport(file) {
      this.$vs.loading();
      var filetitle =
        "DAILY_CLOSING_REPORT_"+moment().format("YYYYMMDDHHmmss");
      this.$http
        .get("/api/sfa/v1/daily-closing-salesman/export", {
          params: {
            file: file,
            title: filetitle,
            territory_ids: this.territoryIDs,
            spv_ids: this.spvIDs,
            sales_ids: this.salesIDs,
            daily_closing_status: this.dailyClosingStatusIDs,
            daily_closing_exception: this.onlyException,
            start_date: this.validity.startDate
              ? moment(this.validity.startDate).format("YYYY-MM-DD")
              : null,
            end_date: this.validity.endDate
              ? moment(this.validity.endDate).format("YYYY-MM-DD")
              : null
          },
        })
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.status == "error") {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle"
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Processing",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle"
            });
          }
        });
    },
    handleSearch(searching) {
      this.table.search = searching;
      this.table.page = 1;
      if (this.table.total > 0) {
        this.getData();
      }
    },
    handleChangePage(page) {
      this.table.page = page;
      if (this.table.total > 0) {
        this.getData();
      }
    },
    handleSort(key, active) {
      this.table.order = key;
      this.table.sort = active;
      if (this.table.total > 0) {
        this.getData();
      }
    },
    handleChangelength(val) {
      this.table.length = val == "All" ? this.table.total : val;
      this.table.page = 1;
      if (this.table.total > 0) {
        this.getData();
      }
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get("/api/sfa/v1/daily-closing-salesman/get-data-report", {
          params: {
            length: this.table.length,
            page: this.table.page,
            search: this.table.search,
            order: this.table.order,
            sort: this.table.sort,
            territory_ids: this.territoryIDs,
            spv_ids: this.spvIDs,
            sales_ids: this.salesIDs,
            daily_closing_status: this.dailyClosingStatusIDs,
            daily_closing_exception: this.onlyException,
            start_date: this.validity.startDate
              ? moment(this.validity.startDate).format("YYYY-MM-DD")
              : null,
            end_date: this.validity.endDate
              ? moment(this.validity.endDate).format("YYYY-MM-DD")
              : null
          },
        })
        .then((resp) => {
          console.log("DATA REPORT", resp);
          if (resp.code == 200) {
            this.table.total = resp.data.total_record;
            this.table.totalPage = resp.data.total_page;
            this.table.totalSearch = resp.data.total_record_search;
            this.table.length = resp.data.total_record_per_page;
            this.table.data = resp.data.records;
            // for (let index = 0; index < resp.data.records.length; index++) {
            //   this.IDItem.push(resp.data.records[index].id);
            // }
            this.setStartEnd();
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
        });
    },
    tableDefaultState() {
      return {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "id",
        sort: "desc",
        total: 0,
        totalPage: 1,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
        is_export_excel: false,
        row_number_start: 1,
        row_number_end: 0,
      };
    },
    handleFilter() {
      this.getData();
    },
    setStartEnd() {
      let valStart =
        this.table.length * this.table.page - this.table.length + 1;
      if (valStart > this.table.total) {
        valStart = 1;
      }
      if (this.table.total == 0) {
        valStart = 0;
      }
      let valEnd = this.table.length * this.table.page;
      if (valEnd > this.table.total) {
        valEnd = this.table.total;
      }
      if (this.table.totalSearch < this.table.total) {
        valEnd = this.table.totalSearch;
      }

      this.table.start = valStart;
      this.table.end = valEnd;
    },
    getTerritory() {
      this.$vs.loading();
      this.$http
        .get("api/sfa/v1/daily-closing-salesman/territory", {
          params: {
            length: 0,
            order: "name",
            sort: "asc",
          },
        })
        .then((resp) => {
          if (resp.code == 200) {
            let data = resp.data.records || [];
            // ✅ tambahkan ALL di paling atas
            if (this.territoryID !== 0) {
              this.optionTerritory = data;
              const found = this.optionTerritory.find(
                (t) => t.id === this.territoryID
              );

              if (found) {
                this.selectedTerritory = found;
              }
            } else {
              this.optionTerritory = [this.ALL_TERRITORY, ...data];
              this.territoryIDs = "0";
            }
          } else {
            this.optionTerritory = [];
            this.selectedTerritory = [];
          }
          this.$vs.loading.close();
        });
    },
    getSalesSupervisor(params) {
      this.$vs.loading();
      this.$http
        .get("api/sfa/v1/monitoring-dashboard/supervisor", {
          params: params,
        })
        .then((resp) => {
          if (resp.code == 200) {
            if (resp.data.records != null) {
              let optionSalesSupervisor = [];
              optionSalesSupervisor.push(this.ALL_OPTION);

              if (resp.data.records != null) {
                resp.data.records.forEach((item) => {
                  optionSalesSupervisor.push(item);
                });
              }

              this.optionSalesSupervisor = optionSalesSupervisor;
              if(!this.selectedSalesSupervisor){
                this.selectedSalesSupervisor = [this.optionSalesSupervisor[0]];
              }
            } else {
              this.optionSalesSupervisor = [];
            }
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
            console.log(resp.data);
          }
        });
    },
    getSales(params) {
      this.$vs.loading();
      this.$http
        .get("api/sfa/v1/personal-territory/salesman-with-territory", {
          params: params,
        })
        .then((resp) => {
          if (resp.code == 200) {
            if (resp.data.records != null) {
              let optionSales = [];

              optionSales.push({
                personal_id: 0,
                personal: {
                  code_external: "ALL",
                  name: "All"
                }
              });

              if (resp.data.records != null) {
                resp.data.records.forEach((item) => {
                  optionSales.push(item);
                });
              }

              this.optionSales = optionSales;
              if(!this.selectedSales){
                this.selectedSales = [optionSales[0]];
              }
            } else {
              this.optionSales = [];
            }
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
            console.log(resp.data);
          }
        });
    },
    handleSearchSupervisor(search) {
        if (!this.selectedTerritory) return
        const ids = [this.selectedTerritory.id];
        const params = {
            territory_ids: ids,
            search: search,
            length: search ? 0 : 5,
        }

        this.getSalesSupervisor(params)
    },
    handleSearchSales(search) {
        if (!this.selectedSalesSupervisor) return
        const ids = this.selectedSalesSupervisor.map(item => item.personal_id);
        
        let param_spv_ids = ids
        
        if (ids.includes(0)) {
            param_spv_ids = []
        }

        const params = {
            territory_id: this.selectedTerritory.id,
            sales_spv_ids: param_spv_ids,
            search: search,
            length: search ? 0 : 5,
        }

        this.getSales(params)
    },
    customLableTerritory({ code, name }) {
      return `${code} ${name}`;
    },
    customLableSalesSupervisor(optionSalesSupervisor) {
      if (optionSalesSupervisor.personal_id === 0) return "ALL";
      return `${optionSalesSupervisor.persona_work_id_number} - ${optionSalesSupervisor.personal_name}`;
    },
    customLableSales(optionSales) {
      if (optionSales.personal_id === 0) return "ALL";
      return `${optionSales.personal.code_external} - ${optionSales.personal.name}`;
    },
    dateFormat(date) {
      let a = null;
      if (date != null) {
        a = moment(date).format("DD MMM YYYY");
      }
      return a;
    },
    formatDate(value) {
      if (!value || value.includes("0001-01-01")) {
        return "";
      }
      if (value) {
        return moment(value).format("YYYY-MM-DD");
      }
    },
    formatDateTime(value) {
      if (!value || value.includes("0001-01-01")) {
        return "";
      }
      if (value) {
        return moment(value)
          .add(-7, "h")
          .utc()
          .local()
          .format("DD MMM YYYY HH:mm:ss");
      }
    },
    formatDateCIT(value) {
      if (!value || value.includes("0001-01-01")) {
        return "";
      }
      if (value) {
        return moment(value)
          .utcOffset(7 * 60)
          .format("DD MMM YYYY HH:mm:ss");
      }
    },
  },
  mounted() {
    this.territoryID = this.$userLogin.territory_id
    this.getTerritory();
  },
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
  },
  watch: {
    validity() {
      // merge start and end date and format it to YYYY-MM-DD
      let startDate = moment(this.validity.startDate).format("YYYY-MM-DD");
      let endDate = moment(this.validity.endDate).format("YYYY-MM-DD");
      let formatDate = startDate + "," + endDate;
      this.$emit("data", formatDate);
    },
    selectedTerritory: {
      handler(newVal, oldVal) {
            const ids = [newVal.id];
            this.territoryIDs = ids.join(',');
            if (ids[0] == 0 && ids.length > 1) {
              this.selectedTerritory.shift()
            } else if(ids.includes(0) && ids.length > 1) {
              this.territoryIDs = "0"
              this.selectedTerritory = [this.ALL_TERRITORY];
            }
            
            if (ids.includes(0)) {
                this.optionSalesSupervisor = []
                this.selectedSalesSupervisor = null
                return
            }

            const params = {
                territory_ids: ids,
                length: 5,
            }

            this.selectedSalesSupervisor = null
            this.optionSalesSupervisor = []
            this.selectedSales = null
            this.optionSales = []
            this.getSalesSupervisor(params)
        },
        deep: true
    },
    selectedSalesSupervisor: {
      handler(newVal, oldVal) {
            if(newVal){
              const ids = newVal.map(item => item.personal_id);
              let param_spv_ids = ids
              this.spvIDs = ids.join(',');
              if (ids[0] == 0 && ids.length > 1) {
                this.selectedSalesSupervisor.shift()
              } else if(ids.includes(0) && ids.length > 1) {
                this.spvIDs = "0"
                this.selectedSalesSupervisor = [this.ALL_OPTION];
              }
              if (ids.includes(0)) {
                  param_spv_ids = []
              }
              const params = {
                  territory_id: this.selectedTerritory.id,
                  sales_spv_ids: param_spv_ids,
                  length: 5,
              }
  
              this.selectedSales = null
              this.optionSales = []
  
              this.getSales(params)
            }
        },
        deep: true
    },
    selectedSales: {
      handler(newVal, oldVal) {
          if(newVal){
            const ids = newVal.map(item => item.personal_id);
            this.salesIDs = ids.join(',');
            
            if (ids[0] == 0 && ids.length > 1) {
              this.selectedSales.shift()
            } else if(ids.includes(0) && ids.length > 1) {
              this.salesIDs = "0"
              this.selectedSales = [this.ALL_OPTION_SALES];
            }
          }
        },
        deep: true
    },
    selectedDailyClosingStatus: {
      handler(newVal, oldVal) {
          if(newVal){
            const ALL = this.optionDailyClosingStatus.find(item => item.id === 0);

            const ids = newVal.map(item => item.id);
            this.dailyClosingStatusIDs = ids.join(',');
            
            if (ids[0] == 0 && ids.length > 1) {
              this.selectedDailyClosingStatus.shift()
            } else if(ids.includes(0) && ids.length > 1) {
              this.dailyClosingStatusIDs = "0"
              this.selectedDailyClosingStatus = [ALL];
            }
          }
        },
        deep: true
    },
  },
};
</script>
